// استيراد دوال React لإدارة الحالات والمراجع والتأثيرات الجانبية
import { useEffect, useRef, useState } from "react";
// استيراد مكون Form من React Bootstrap
import { Form } from "react-bootstrap";
// استيراد كائن Axios المهيأ
import { Axios } from "../../../API/Axios";
// استيراد رابط API الخاص بالمستخدم
import { USER } from "../../../API/Api";
// استيراد مكون التحميل
import Loading from "../../../components/Loading/Loding";
// استيراد سياق اللغة
import { useLanguage } from "../../../Context/LanguageContext";
// استيراد ملف الأنماط
import "../../../components/Dashboard/FormPage.css";

// تعريف أكواد الأدوار المتاحة في النظام
const ROLE_CODES = [ "1995", "2001", "1996", "1999" ];

// المكون الرئيسي لإضافة مستخدم جديد
export default function AddUser ()
{
    // استيراد دالة الترجمة من سياق اللغة
    const { t } = useLanguage();
    // حالة لتخزين بيانات النموذج (الاسم، البريد الإلكتروني، الدور، كلمة المرور)
    const [ formData, setFormData ] = useState( { name: "", email: "", role: "", password: "" } );
    // حالة التحميل
    const [ loading, setLoading ] = useState( false );
    // مرجع لتركيز المؤشر على حقل الاسم
    const focus = useRef();

    // تأثير جانبي لتركيز المؤشر على حقل الاسم عند تحميل المكون
    useEffect( () =>
    {
        focus.current.focus(); // تركيز المؤشر على حقل الاسم
    }, [] ); // يتم التنفيذ مرة واحدة عند تحميل المكون

    // دالة معالجة تغيير المدخلات
    const handleChange = ( e ) =>
    {
        // استخراج اسم الحقل والقيمة من الحدث
        const { name, value } = e.target;
        // تحديث بيانات النموذج مع الاحتفاظ بالبيانات السابقة
        setFormData( { ...formData, [ name ]: value } );
    };

    // دالة غير متزامنة لمعالجة تقديم النموذج (إضافة مستخدم جديد)
    async function handleSubmit ( e )
    {
        // منع إعادة تحميل الصفحة
        e.preventDefault();
        // تفعيل حالة التحميل
        setLoading( true );
        try
        {
            // إرسال طلب POST لإضافة مستخدم جديد
            await Axios.post( `${ USER }/add`, formData );
            // إعادة توجيه المستخدم إلى صفحة قائمة المستخدمين بعد النجاح
            window.location.pathname = "/dashboard/users";
        } catch ( error )
        {
            // طباعة الخطأ في وحدة التحكم
            console.error( error );
            // إلغاء حالة التحميل في حالة الخطأ
            setLoading( false );
        }
    }

    // التحقق من صحة البيانات قبل تمكين زر الإرسال
    const canSubmit =
        formData.name.length > 1 && // اسم المستخدم أكبر من حرف واحد
        formData.email.length > 1 && // البريد الإلكتروني أكبر من حرف واحد
        formData.password.length > 6 && // كلمة المرور أكبر من 6 أحرف
        formData.role !== ""; // تم اختيار دور

    // عرض واجهة إضافة مستخدم جديد
    return (
        <>
            {/* عرض مكون التحميل إذا كانت الحالة true */ }
            { loading && <Loading /> }
            {/* حاوية النموذج */ }
            <div className="form-page-wrap">
                {/* نموذج إضافة المستخدم */ }
                <Form className="form-page-card" onSubmit={ handleSubmit }>
                    {/* عنوان النموذج المترجم */ }
                    <h3 className="form-page-title">{ t( 'usersForm.addTitle' ) }</h3>

                    {/* حقل الاسم */ }
                    <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>{ t( 'usersForm.nameLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.name } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="name" // اسم الحقل
                            type="text" // نوع الإدخال نص
                            placeholder={ t( 'usersForm.namePlaceholder' ) } // النص الافتراضي المترجم
                            ref={ focus } // ربط المرجع للتركيز
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل البريد الإلكتروني */ }
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>{ t( 'usersForm.emailLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.email } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="email" // اسم الحقل
                            type="email" // نوع الإدخال بريد إلكتروني
                            placeholder={ t( 'usersForm.emailPlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل كلمة المرور */ }
                    <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Label>{ t( 'usersForm.passwordLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.password } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="password" // اسم الحقل
                            type="password" // نوع الإدخال كلمة مرور
                            placeholder={ t( 'usersForm.passwordPlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل الدور (قائمة منسدلة) */ }
                    <Form.Group className="mb-3" controlId="formRole">
                        <Form.Label>{ t( 'usersForm.roleLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Select
                            value={ formData.role } // القيمة المحددة
                            onChange={ handleChange } // دالة التغيير
                            name="role" // اسم الحقل
                            required // الحقل مطلوب
                        >
                            <option disabled value="">{ t( 'usersForm.selectRole' ) }</option> {/* الخيار الافتراضي المترجم */ }
                            {/* تكرار على أكواد الأدوار وعرضها مترجمة */ }
                            { ROLE_CODES.map( ( code ) => (
                                <option key={ code } value={ code }>{ t( `roles.${ code }` ) }</option>
                            ) ) }
                        </Form.Select>
                    </Form.Group>

                    {/* زر الإرسال - يتم تعطيله إذا كانت البيانات غير صالحة */ }
                    <button disabled={ !canSubmit } className="form-page-submit" type="submit">
                        { t( 'usersForm.save' ) } {/* نص الزر المترجم */ }
                    </button>
                </Form>
            </div>
        </>
    );
}